import { getRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function getSavedTripSearchesRequest(filter) {
	let url = savedTripSearches.getPath();
	let response = await getRequest(url, filter);
	return response;
}
